import { WarningAlert } from '@/components';
import { YIELD_BEARING_ASSET } from '@/utils/strings';
const WalletFoundButNoAssetsFoundToDeployWarningAlert = () => (
  <WarningAlert
    title={YIELD_BEARING_ASSET.WALLET_FOUND_BUT_NO_ASSETS_FOUND_TITLE}
    description={
      YIELD_BEARING_ASSET.WALLET_FOUND_BUT_NO_ASSETS_FOUND_DESCRIPTION
    }
  />
);
export default WalletFoundButNoAssetsFoundToDeployWarningAlert;
